export default __webpack_public_path__ + "static/media/success-toast-checkmark-icon.1b0f57ae.svg";